import { useQuery } from "@tanstack/react-query";
import useDebounce from "../external/ensolvers-core-frontend-mui/hooks/useDebounce";
import FAQs from "../models/FAQs";
import FAQService from "../services/FAQService";
import { QueryKeyFactory } from "../services/queryKeys";
import { unwrap } from "../utils/queryFn";
import { TABLE_QUERY_STALE_TIME } from "../utils/tableQuery";

export const faqKeys = new QueryKeyFactory(FAQService.path);

export const useFAQSection = (title: string, pageSize: number) => {
  const debouncedTitle = useDebounce(title, 1000);

  const questionsQuery = useQuery({
    queryKey: faqKeys.list({ page: 0, pageSize, title: debouncedTitle }),
    queryFn: () => unwrap(FAQService.findFAQsFilter(0, pageSize, debouncedTitle)),
    staleTime: TABLE_QUERY_STALE_TIME,
  });

  return {
    questions: (questionsQuery.data?.content ?? []) as FAQs[],
    isLoading: questionsQuery.isFetching || title !== debouncedTitle,
  };
};
